module.exports = __webpack_public_path__ + "static/media/user5.8884c090.jpg";